module.exports = __webpack_public_path__ + "img/weloop-logo.ee76507e.png";